import { createContext } from 'react';

import type { GoogleLoginInput, LoginInput } from './types';

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated';

export interface AuthContextValue {
  status: AuthStatus;
  signIn: (input: LoginInput) => Promise<void>;
  /** Wave 9 — exchange a Google credential for our JWT pair and bootstrap the session. */
  signInWithGoogle: (input: GoogleLoginInput) => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
